import {API} from "aws-amplify";
import {getInputContext} from "../utils/api-utils";
import {CASE_MANAGEMENT_SERVICE_API, UPDATE_CASE_STATUS} from "../constants/api-paths";
import {STRYFE_CLIENTID, UPDATE_CASE_STATUS_REQUEST_TYPE} from "../components/StryfeAPI/Constants";

export async function updateCaseStatus(useCaseName, caseId, status, updateMessage, falsePositiveReason) {
    const request = {
        useCaseName: useCaseName,
        caseId: caseId,
        clientId: STRYFE_CLIENTID,
        status: status,
        updateMessage: updateMessage,
        falsePositiveReason: falsePositiveReason,
    };

    const input = await getInputContext();
    input.body.requestType = UPDATE_CASE_STATUS_REQUEST_TYPE;
    input.body.requestString = JSON.stringify(request);

    const resp = await API.post(CASE_MANAGEMENT_SERVICE_API, UPDATE_CASE_STATUS, input);

    if (resp.statusCode !== "200") {
        throw new Error("Failed to update case status for caseId: " + caseId);
    }
}
